import { STEPS as steps } from '../content/site'

export default function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      className="relative py-[clamp(80px,12vh,160px)]"
      style={{ background: 'linear-gradient(180deg, #0d1117 0%, #111827 100%)' }}
    >
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="hiw-header text-center mb-16">
          <span className="text-xs font-mono uppercase tracking-[0.08em] text-[#06b6d4]">
            HOW IT WORKS
          </span>
          <h2 className="mt-4 text-[clamp(28px,3vw,42px)] font-semibold leading-[1.15] tracking-[-0.015em] text-white">
            From scattered bids to your inbox in 3 steps
          </h2>
        </div>

        <div className="hiw-steps grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((step, i) => {
            const Icon = step.icon
            return (
              <div key={step.num} className="hiw-step relative">
                <div className="relative text-center">
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 text-[120px] font-bold text-[#06b6d4]/[0.07] leading-none select-none pointer-events-none font-mono">
                    {step.num}
                  </span>

                  <div className="relative pt-8">
                    <div className="w-14 h-14 rounded-xl bg-[#06b6d4]/10 border border-[#06b6d4]/20 flex items-center justify-center mx-auto mb-6">
                      <Icon size={28} className="text-[#06b6d4]" />
                    </div>

                    <h3 className="text-[clamp(18px,2vw,24px)] font-semibold text-white leading-[1.3]">
                      {step.title}
                    </h3>
                    <p className="mt-3 text-base leading-[1.6] text-[#9ca3af]">
                      {step.desc}
                    </p>
                  </div>
                </div>

                {i < steps.length - 1 && (
                  <div className="hiw-connector hidden md:block absolute top-[60px] -right-4 w-8 h-px bg-gradient-to-r from-[#06b6d4] to-[#3b82f6] origin-left" />
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
